<template>
  <div class="application">
    <AppHiddenFields :variation="variation"/>

    <AppHeader invert-phone />

    <div class="application__content">
      <!-- step content goes here -->
      <StepHandler ref="StepHandler"/>
    </div>

    <AppFooter/>

    <AppCookieManager/>
  </div>
</template>

<script>
import AppCookieManager from '@/components/common/hidden-fields/AppCookieManager'
import AppFooter from './layout/AppFooter'
import AppHeader from '@/components/common/layout/AppHeader'
import AppHiddenFields from '@/components/common/hidden-fields/AppHiddenFields'
import StepHandler from './StepHandler'

export default {
  // Name
  name: 'application',

  // Components
  components: {
    AppCookieManager,
    AppFooter,
    AppHeader,
    AppHiddenFields,
    StepHandler
  },

  // Data
  data () {
    return {
      variation: 'offer'
    }
  }
}
</script>

<style scoped lang="scss">
@import url("https://use.typekit.net/glh5zox.css");

.application {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;

  &__content {
    position: relative;
    min-height: 75vh;
  }
}
</style>

<style  lang="scss">
@import '@/styles/variables/_core.scss';
@import '@/styles/variables/_typography.scss';
@import '@/styles/_visibility.scss';
@import '@/styles/_layout.scss';
@import '@/styles/partials/_spacing.scss';
@import '@/styles/partials/_flexbox-grid-custom.scss';
@import "~@vivid-web/flexboxgrid-sass/src/flexboxgrid";

@media (min-width: 1200px) {
  .step-tooltip__icon {
    display: none !important;
  }
}
.step-tooltip__text {
  color: $brand-color-black;
}

h1, h2, h3 {
  font-family: $font-family-title;
}

h2 {
  color: $theme-text-grey-dark;
}

h3 {
  color: $theme-text-grey-dark;
}

body,small,p,h1,h2,h3,h4,h5,h6, .application__content .app-input__container .app-input__label{
  color: $theme-text-grey-dark;
}
</style>
